'use strict';
exports.default = exports;
const moment = require('moment');

exports.vuetify2firestore = function(input) {
  return moment(input).toDate();
};


exports.firestore2vuetify = function(input) {
  if(input && typeof input.toDate==='function') {
    return moment(input.toDate()).format('YYYY-MM-DD');
  }
  return null;
};


exports.DATE_ISO = 'YYYY-MM-DD';
exports.DATE_TIME_ISO = 'YYYY-MM-DDTHH:mm:ss';
exports.DATE_MONTH = 'YYYY-MM';
exports.MONTH_ABBREVIATIONS = [
  'JAN', 'FEV', 'MAR', 'ABR', 'MAIO', 'JUN',
  'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
];

/**
 * O dia `day` do mês de `reference`, em 'YYYY-MM-DD', limitado ao último dia do mês: dia 31 em
 * fevereiro vira 28 (ou 29). É o dia do MÊS — no moment, `set('day', n)` é o dia da SEMANA, e
 * valor acima de 6 transborda para as semanas seguintes (foi assim que o recorrente gravava o
 * vencimento numa quarta ou numa sexta qualquer, #1282). E `set('date', 31)` em fevereiro iria
 * para 3 de março.
 *
 * @param {*} reference data de referência (qualquer entrada do moment)
 * @param {number|string} day dia do mês, de 1 a 31
 * @returns {?string} a data, ou null quando `day` não é um dia válido
 */
exports.dayOfMonthIso = function(reference, day) {
  const n = Math.trunc(Number(day));
  if (!Number.isFinite(n) || n<1) {
    return null;
  }
  const m = moment(reference);
  return m.date(Math.min(n, m.daysInMonth())).format('YYYY-MM-DD');
};


function jx_datenum(v, date1904=undefined) {
  if (date1904) v+=1462;
  const epoch = Date.parse(v);
  // @ts-ignore
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

exports.jx_datenum = jx_datenum;

/**
 *
 * @param {any} input
 * @param {null | string} modelFormat Só é relevante no type === string
 *
 * @returns {moment | null} value
 */
function toMoment(input, modelFormat = null) {
  if(!input) {
    return null;
  }
  let value = null;
  if(input instanceof moment) {
    value = moment(input);
  }
  else if(typeof input.toDate ==='function') {
    value = moment(input.toDate());
  }
  else if(typeof input==='string') {
    value = moment(input, modelFormat);
  }
  else if(input.seconds>0 || input.nanoseconds>0) {
    value = moment((input.seconds*1000)+(input.nanoseconds/10e6));
  }
  else {
    value = moment(input);
  }
  if(value?.isValid?.()) {
    return value;
  }
  return null;
}
exports.toMoment = toMoment;

/**
 * Obtém qualquer tipo de data e retorna em formato moment ou formatada como string
 * @param {any} dateValue - data a ser convertida
 * @param {string|null} [format] - formato opcional para retornar a data como string
 * @param {string|null} [modelFormat] - formato a ser considerado se dateValue for string
 * @returns {moment|null} - data em formato moment ou null se não for possível converter
 */
function customBetterAllDatesToMoment(dateValue, format = null, modelFormat = null) {
  try {

    if (!dateValue || dateValue === '-' || dateValue === '') {
      return null;
    }

    let momentDate;

    if (dateValue instanceof moment) {
      momentDate = moment(dateValue);
    }
    else if (dateValue instanceof Date) {
      momentDate = moment(dateValue);
    }
    else if (typeof dateValue.toDate === 'function') {
      momentDate = moment(dateValue.toDate());
    }
    else if (typeof dateValue === 'string') {
      momentDate = modelFormat ? moment(dateValue, modelFormat) : moment(dateValue);
    }
    else if (dateValue.seconds !== undefined && dateValue.nanoseconds !== undefined) {
      momentDate = moment((dateValue.seconds * 1000) + (dateValue.nanoseconds / 10e6));
    }
    else if (dateValue.seconds) {
      momentDate = moment.unix(dateValue.seconds);
    }
    else if (dateValue.nanoseconds) {
      momentDate = moment.unix(dateValue.nanoseconds / 10e9);
    }
    else {
      momentDate = moment(dateValue);
    }

    if (!momentDate?.isValid?.()) {
      return null;
    }

    return momentDate;
  } catch (error) {
    console.error('Erro ao converter data:', error);
    return null;
  }
}

exports.customBetterAllDatesToMoment = customBetterAllDatesToMoment;

/**
 * Formata uma data em formato abreviado personalizado
 * @param {any} date - data a ser formatada
 * @param {Object} [options] - opções de configuração
 * @param {boolean} [options.showHour=true] - se deve mostrar a horas
 * @param {boolean} [options.showYear=true] - se deve mostrar o ano
 * @param {boolean} [options.showDay=true] - se deve mostrar o dia do mês
 * @param {boolean} [options.resumedYear=false] - se deve mostrar o ano resumido (YY)
 * @param {boolean} [options.showSeconds=true] - se deve mostrar os segundos
 * @param {boolean} [options.showWeekDay=false] - se deve mostrar o dia da semana
 * @param {boolean} [options.resumedWeekDay=true] - se deve mostrar o dia da semana resumido (DOM, SEG)
 * @param {boolean} [options.resumedMonth=true] - se deve mostrar o mês resumido (FEV)
 * @param {boolean} [options.useOrdinalFirst=true] - se deve usar o ordinal (1º) para o primeiro dia do mês
 * @param {string} [options.locale='pt-br'] - locale a ser usado
 * @returns {string} - data formatada no formato abreviado
 */
exports.customBetterFormatDateToAbbr = function(date = null, options = {}) {

  const defaultOptions = {
    showHour: true,
    showYear: true,
    showDay: true,
    showSeconds: true,
    showWeekDay: false,
    resumedYear: false,
    resumedWeekDay: true,
    resumedMonth: true,
    useOrdinalFirst: true,
    locale: 'pt-br',
  };

  const currentOptions = { ...defaultOptions, ...options };
  const { showHour, showYear, showDay, resumedYear, showSeconds, showWeekDay, resumedWeekDay, resumedMonth, useOrdinalFirst, locale } = currentOptions;

  let momentDate = customBetterAllDatesToMoment(date || new Date());
  if (!momentDate) {
    momentDate = moment();
  }

  momentDate.locale(locale);

  let dateFormat = '';

  if (showWeekDay) {
    dateFormat += resumedWeekDay ? 'ddd ' : 'dddd ';
  }

  if (showDay) {
    dateFormat += 'DD ';
  }
  dateFormat += resumedMonth ? 'MMM ' : 'MMMM ';

  if (showYear) {
    dateFormat += resumedYear ? 'YY' : 'YYYY';
  }

  let formattedDate = momentDate.format(dateFormat).toUpperCase();

  if (locale === 'pt-br' || locale === 'pt') {
    if (resumedMonth) {
      formattedDate = formattedDate.replace(/\bMAI\b/, 'MAIO');
    }
  }

  if (showDay && useOrdinalFirst && momentDate.date() === 1) {
    formattedDate = formattedDate.replace(/\b01\b/, '1º');
  }

  // Remove espaços extras no final se o ano não foi incluído
  formattedDate = formattedDate.trim();

  if (showHour) {
    const timeFormat = showSeconds ? 'HH[h]mm[m]ss[s]' : 'HH[h]mm[m]';
    const formattedTime = momentDate.format(timeFormat);
    return `${formattedDate} - ${formattedTime}`;
  }

  return formattedDate;
};

/**
 * Formata um objeto moment como string usando o formato especificado
 * @param {any} date - data a ser formatada (moment, Date, Timestamp, iso, etc)
 * @param {string} format - formato para a string resultante
 * @returns {string|null} - data formatada como string ou null se não for possível converter
 */
function customBetterFormatMoment(date, format) {
  try {
    const momentDate = customBetterAllDatesToMoment(date);
    if (!momentDate) {
      return null;
    }
    return momentDate.format(format);
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return null;
  }
}

exports.customBetterFormatMoment = customBetterFormatMoment;


exports.customBetterTimeDuration = function(startTime, endTime) {
  if (!startTime || !endTime) return '';

  const start = moment(startTime.toDate());
  const end = moment(endTime.toDate());
  let diff = end.diff(start, 'minutes');
  diff = (diff > 0) ? diff : diff * -1;
  const hours = Math.floor(diff / 60);
  const minutes = diff % 60;
  return `${(hours > 9) ? hours : '0' + hours}:${(minutes > 9) ? minutes : '0' + minutes}`;
};

/**
 * Calcula a diferença de tempo entre início e fim de um intervalo
 * @param {Date|string|moment} startTime - Horário de início
 * @param {Date|string|moment} endTime - Horário de fim
 * @param {Object} options - Opções de configuração
 * @param {string} options.format - Formato de saída: 'hours' (número de horas), 'formatted' (HH:MM)
 * @param {boolean} options.roundUp - Se deve arredondar para cima para horas completas
 * @returns {number|string} - Diferença em horas ou string formatada
 */
exports.customBetterCalculateTimeDifference = function(startTime, endTime, options = {}) {
  // Valores padrão para as opções
  const format = options.format || 'hours';
  const roundUp = options.roundUp !== undefined ? options.roundUp : true;

  // Retornar valor padrão se algum parâmetro estiver faltando
  if (!startTime || !endTime) {
    return format === 'formatted' ? '00:00' : 0;
  }

  // Converter entradas para objetos moment
  const start = moment.isMoment(startTime) ? startTime.clone() : moment(startTime);
  const end = moment.isMoment(endTime) ? endTime.clone() : moment(endTime);

  // Verificar se são datas válidas
  if (!start.isValid() || !end.isValid()) {
    return format === 'formatted' ? '00:00' : 0;
  }

  // Ajuste para casos onde o intervalo atravessa a meia-noite
  if (end.diff(start) < 0) {
    end.add(1, 'day');
  }

  // Calcular diferença em minutos
  const diffMinutes = end.diff(start, 'minutes');

  // Caso especial: se os horários forem iguais, retorna 1 hora ou "01:00"
  if (diffMinutes === 0 && start.isSame(end)) {
    return format === 'formatted' ? '01:00' : 1;
  }

  if (format === 'hours') {
    // Converter para horas e possivelmente arredondar para cima
    const diffHours = end.diff(start, 'hour', true);
    return roundUp ? Math.ceil(diffHours) : diffHours;
  } else {
    // Formato HH:MM
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return `${hours > 9 ? hours : '0' + hours}:${minutes > 9 ? minutes : '0' + minutes}`;
  }
};

/**
 * Calcula idade de forma inteligente e flexível
 *
 * Função centralizada para cálculo de idade com múltiplos formatos de saída:
 * - Número simples (apenas anos)
 * - String formatada com unidade apropriada (anos/meses/dias)
 * - Objeto detalhado com anos, meses e dias
 *
 * Seleciona automaticamente a melhor unidade de exibição:
 * - Exibe anos se >= 1 ano
 * - Exibe meses se < 1 ano mas >= 1 mês
 * - Exibe dias se < 1 mês
 *
 * @param {any} birthDate - Data de nascimento (aceita Date, string ISO "2001-04-21", formato brasileiro "21/04/2001", Timestamp, moment)
 * @param {any} [referenceDate] - Data de referência para cálculo (padrão: hoje)
 * @param {Object} [options] - Opções de formatação e retorno
 * @param {string} [options.returnType='formatted'] - Tipo de retorno: 'formatted' | 'years' | 'detailed'
 * @param {boolean} [options.showPrefix=true] - Mostrar "idade: " no início (apenas para returnType='formatted')
 * @param {string} [options.locale='pt-br'] - Locale para formatação (pt-br, en, es)
 * @returns {string|number|{years: number, months: number, days: number}} - Idade no formato especificado
 *
 * @example
 * // Retorno formatado (padrão) - aceita múltiplos formatos de data
 * customBetterCalculateAge('2001-04-21')  // ISO
 * // "idade: 23 anos"
 *
 * customBetterCalculateAge('21/04/2001')  // Formato brasileiro
 * // "idade: 23 anos"
 *
 * customBetterCalculateAge(new Date(2000, 0, 1))  // Date object
 * // "idade: 25 anos"
 *
 * customBetterCalculateAge(new Date(2024, 10, 1))
 * // "idade: 2 meses"
 *
 * customBetterCalculateAge(new Date(2025, 0, 5))
 * // "idade: 10 dias"
 *
 * // Sem prefixo
 * customBetterCalculateAge('21/04/2001', null, { showPrefix: false })
 * // "23 anos"
 *
 * // Apenas anos (number)
 * customBetterCalculateAge('2001-04-21', null, { returnType: 'years' })
 * // 23
 *
 * // Detalhado (object)
 * customBetterCalculateAge('15/01/2023', '20/03/2025', { returnType: 'detailed' })
 * // { years: 2, months: 2, days: 5 }
 *
 * // Em inglês
 * customBetterCalculateAge('21/04/2001', null, { locale: 'en' })
 * // "age: 23 years"
 */
exports.customBetterCalculateAge = function(birthDate = null, referenceDate = null, options = {}) {
  const defaultOptions = {
    returnType: 'formatted',
    showPrefix: true,
    locale: 'pt-br'
  };

  const currentOptions = { ...defaultOptions, ...options };
  const { returnType, showPrefix, locale } = currentOptions;

  // Validação de entrada
  if (!birthDate) {
    if (returnType === 'years') return 0;
    if (returnType === 'detailed') return { years: 0, months: 0, days: 0 };
    return '';
  }

  // Converte qualquer formato de data para moment usando customBetterAllDatesToMoment
  // Aceita: ISO "2001-04-21", brasileiro "21/04/2001", Date, Timestamp, moment
  const birth = exports.customBetterAllDatesToMoment(birthDate);
  const reference = exports.customBetterAllDatesToMoment(referenceDate || moment());

  // Validação dos objetos moment
  if (!birth || !birth.isValid()) {
    if (returnType === 'years') return 0;
    if (returnType === 'detailed') return { years: 0, months: 0, days: 0 };
    return '';
  }

  if (!reference || !reference.isValid()) {
    if (returnType === 'years') return 0;
    if (returnType === 'detailed') return { years: 0, months: 0, days: 0 };
    return '';
  }

  // Cálculo detalhado de idade
  const totalMonths = reference.diff(birth, 'months');
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  // Calcula dias remanescentes
  const birthWithYearsMonths = birth.clone().add(totalMonths, 'months');
  const days = reference.diff(birthWithYearsMonths, 'days');

  // Retorno baseado em returnType
  if (returnType === 'years') {
    return years;
  }

  if (returnType === 'detailed') {
    return { years, months, days };
  }

  // returnType === 'formatted' (padrão)
  const prefix = showPrefix ? 'idade: ' : '';

  // Textos por locale
  const texts = {
    'pt-br': {
      year: { singular: 'ano', plural: 'anos' },
      month: { singular: 'mês', plural: 'meses' },
      day: { singular: 'dia', plural: 'dias' }
    },
    'en': {
      year: { singular: 'year', plural: 'years' },
      month: { singular: 'month', plural: 'months' },
      day: { singular: 'day', plural: 'days' }
    },
    'es': {
      year: { singular: 'año', plural: 'años' },
      month: { singular: 'mes', plural: 'meses' },
      day: { singular: 'día', plural: 'días' }
    }
  };

  const t = texts[locale] || texts['pt-br'];

  // Seleciona a melhor unidade de exibição
  let result = '';
  if (years > 0) {
    result = `${prefix}${years} ${years === 1 ? t.year.singular : t.year.plural}`;
  } else if (months > 0) {
    result = `${prefix}${months} ${months === 1 ? t.month.singular : t.month.plural}`;
  } else if (days > 0) {
    result = `${prefix}${days} ${days === 1 ? t.day.singular : t.day.plural}`;
  }

  return result;
};

/**
 * Formatar duração em milissegundos para formato legível
 * @param {number} ms - Duração em milissegundos
 * @param {Object} [options] - opções de configuração
 * @param {string} [options.style='auto'] - 'auto', 'digital', 'verbose'
 * @param {boolean} [options.showMillis=false] - mostrar milissegundos quando relevante
 * @param {boolean} [options.alwaysShowHours=false] - sempre mostrar horas mesmo se zero
 * @returns {string} - duração formatada
 */
exports.customBetterFormatDuration = function(ms, options = {}) {
  try {
    const defaultOptions = {
      style: 'auto',
      showMillis: false,
      alwaysShowHours: false
    };

    const currentOptions = { ...defaultOptions, ...options };
    const { style, showMillis, alwaysShowHours } = currentOptions;

    if (!ms || ms === 0) return '0ms';

    // Usar Moment.js Duration - MUITO MAIS SIMPLES!
    const duration = moment.duration(ms);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const millis = duration.milliseconds();

    // Para valores muito pequenos (menos de 1 segundo)
    if (ms < 1000) {
      return `${Math.round(ms)}ms`;
    }

    // Para segundos (menos de 1 minuto)
    if (ms < 60000 && !alwaysShowHours) {
      const fractionalSeconds = seconds + (millis / 1000);
      return showMillis ? `${fractionalSeconds.toFixed(2)}s` : `${fractionalSeconds.toFixed(1)}s`;
    }

    // Para minutos ou mais
    switch (style) {
      case 'digital':
        const digitHours = alwaysShowHours || hours > 0 ? `${hours.toString().padStart(2, '0')}:` : '';
        const digitMinutes = `${minutes.toString().padStart(2, '0')}:`;
        const digitSeconds = `${seconds.toString().padStart(2, '0')}`;
        const digitMillis = showMillis ? `.${millis.toString().padStart(3, '0')}` : '';
        return `${digitHours}${digitMinutes}${digitSeconds}${digitMillis}`;

      case 'verbose':
        let result = '';
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0) result += `${minutes}m `;
        if (seconds > 0 || result === '') {
          const fractionalSeconds = seconds + (showMillis ? millis / 1000 : 0);
          result += showMillis ? `${fractionalSeconds.toFixed(2)}s` : `${seconds}s`;
        }
        return result.trim();

      case 'auto':
      default:
        if (hours > 0) {
          const fractionalSeconds = seconds + (showMillis ? millis / 1000 : 0);
          return showMillis
            ? `${hours}h ${minutes}m ${fractionalSeconds.toFixed(2)}s`
            : `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
          const fractionalSeconds = seconds + (showMillis ? millis / 1000 : 0);
          return showMillis
            ? `${minutes}m ${fractionalSeconds.toFixed(2)}s`
            : `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    }
  } catch (error) {
    console.error('Erro ao formatar duração:', error);
    return `${ms}ms`;
  }
};

/**
 * Formata período de datas para exibição em relatórios
 *
 * @param {any} dateBegin - Data início
 * @param {any} dateEnd - Data fim
 * @param {Object} [options] - Opções de configuração
 * @param {boolean} [options.showPrefix=false] - Exibir prefixo "Período de"
 * @param {boolean} [options.useConnector=false] - Usar "A" como conector
 * @param {boolean} [options.resumedYear=false] - Ano resumido (25) ou completo (2025)
 * @returns {string} - Período formatado
 *
 * @example
 * customBetterFormatPeriod('2025-01-01', '2025-01-31') // "JAN 2025"
 * customBetterFormatPeriod('2025-01-01', '2025-03-31') // "JAN-MAR 2025"
 * customBetterFormatPeriod('2024-12-01', '2025-02-28') // "DEZ 2024-FEV 2025"
 * customBetterFormatPeriod('2025-01-01', '2025-03-31', { showPrefix: true, useConnector: true }) // "Período de JAN A MAR 2025"
 * customBetterFormatPeriod('2025-05-01', '2025-05-31') // "MAIO 2025" (correção automática)
 */
exports.customBetterFormatPeriod = function(dateBegin, dateEnd, options = {}) {
  const defaultOptions = {
    showPrefix: false,
    useConnector: false,
    resumedYear: false
  };

  const currentOptions = { ...defaultOptions, ...options };
  const { showPrefix, useConnector, resumedYear } = currentOptions;

  if (!dateBegin || !dateEnd) {
    return showPrefix ? 'Período não definido' : 'PERÍODO NÃO DEFINIDO';
  }

  const startMoment = exports.customBetterAllDatesToMoment(dateBegin);
  const endMoment = exports.customBetterAllDatesToMoment(dateEnd);

  if (!startMoment || !endMoment || !startMoment.isValid() || !endMoment.isValid()) {
    return showPrefix ? 'Período inválido' : 'PERÍODO INVÁLIDO';
  }

  const startMonth = startMoment.format('MMM').toUpperCase().replace(/^MAI$/, 'MAIO');
  const endMonth = endMoment.format('MMM').toUpperCase().replace(/^MAI$/, 'MAIO');
  const startYear = startMoment.format(resumedYear ? 'YY' : 'YYYY');
  const endYear = endMoment.format(resumedYear ? 'YY' : 'YYYY');

  let period;

  if (startMonth === endMonth && startYear === endYear) {
    period = `${startMonth} ${startYear}`;
  }
  else if (startYear === endYear) {
    const connector = useConnector ? ' A ' : '-';
    period = `${startMonth}${connector}${endMonth} ${startYear}`;
  }
  else {
    const connector = useConnector ? ' A ' : '-';
    period = `${startMonth} ${startYear}${connector}${endMonth} ${endYear}`;
  }

  return showPrefix ? `Período de ${period}` : period;
};

/**
 * Calcula array de meses entre duas datas
 *
 * @param {any} dateBegin - Data início (aceita qualquer formato)
 * @param {any} dateEnd - Data fim (aceita qualquer formato)
 * @returns {string[]} Array de meses no formato YYYY-MM
 *
 * @example
 * calculateMonths('2025-01-15', '2025-03-20') // ['2025-01', '2025-02', '2025-03']
 * calculateMonths('2025-01-01', '2025-01-31') // ['2025-01']
 * calculateMonths(new Date(2025, 0, 1), new Date(2025, 2, 31)) // ['2025-01', '2025-02', '2025-03']
 */
exports.calculateMonths = function(dateBegin, dateEnd) {
  const months = [];

  const start = exports.customBetterAllDatesToMoment(dateBegin);
  const end = exports.customBetterAllDatesToMoment(dateEnd);

  if (!start || !end || !start.isValid() || !end.isValid()) {
    return months;
  }

  const startOfMonth = start.clone().startOf('month');
  const endOfMonth = end.clone().startOf('month');

  const current = startOfMonth.clone();
  while (current.isSameOrBefore(endOfMonth)) {
    months.push(current.format('YYYY-MM'));
    current.add(1, 'month');
  }

  return months;
};

/**
 * Formata mês para exibição
 *
 * Wrapper de customBetterFormatDateToAbbr configurado para exibir
 * apenas mês e ano abreviado (ex: "JAN 25", "MAIO 25").
 *
 * @param {any} month - Mês (aceita YYYY-MM, Date, moment, etc)
 * @param {boolean} [resumedYear=true] - Se deve mostrar o ano resumido (YY) ou completo (YYYY)
 * @returns {string} Mês formatado (ex: "JAN 25", "MAIO 25", "JAN 2025")
 *
 * @example
 * formatMonthName('2025-01') // "JAN 25"
 * formatMonthName('2025-05') // "MAIO 25"
 * formatMonthName('2025-05', false) // "MAIO 2025"
 * formatMonthName(new Date(2025, 0, 15)) // "JAN 25"
 */
exports.formatMonthName = function(month, resumedYear = true) {
  return exports.customBetterFormatDateToAbbr(month, {
    showDay: false,
    showHour: false,
    showYear: true,
    resumedYear: resumedYear,
    resumedMonth: true
  });
};